import styled from '@emotion/styled';

import { createClassNames } from '@hrworks/design-system/functions';
import { mq } from '@hrworks/design-system/utilities';

import { Alert, AlertContent, AlertStyles } from '../../Alert';
import { IconButtonStyles } from '../../IconButton';

const Root = styled(Alert)(({ theme }) => ({
  position: 'absolute',
  right: 0,
  bottom: 0,
  width: '100%',
  zIndex: `calc(${theme.variables.zIndex.notifications} - var(--toast-index))`,
  '--offset-y': `calc(-1 * var(--toast-offset-y) - var(--toast-index) * ${theme.eclipseTier1.spacing['8px']})`,
  transform: 'translateY(var(--offset-y))',
  transitionProperty: 'opacity, transform',
  transitionDuration: theme.variables.animationDuration.normal,
  transitionTimingFunction: 'ease-out',
  ':focus-visible': {
    outline: `2px solid ${theme.eclipseTier2Color.border.focus}`,
  },
  '&[data-starting-style], &[data-ending-style]': {
    opacity: 0,
    transform: 'translateY(calc(var(--offset-y) + 150%))',
  },
  '&[data-swiping]': {
    transitionProperty: 'opacity',
    transform: 'translate(var(--toast-swipe-movement-x), calc(var(--offset-y) + var(--toast-swipe-movement-y)))',
  },
  '&[data-ending-style][data-swipe-direction="right"]': {
    transform: 'translateX(calc(var(--toast-swipe-movement-x) + 150%)) translateY(var(--offset-y))',
  },
  '&[data-ending-style][data-swipe-direction="down"]': {
    transform: 'translateY(calc(var(--offset-y) + var(--toast-swipe-movement-y) + 150%))',
  },

  [AlertStyles.sel.Content]: {
    flexWrap: 'nowrap',
  },
}));

// Long text wraps inside the content instead of pushing the close button onto a second row.
const Content = styled(AlertContent)({
  flex: 1,
  minWidth: 0,
});

const CloseWrapper = styled.div(({ theme }) => ({
  marginRight: `calc(-1 * ${theme.eclipseTier1.spacing['12px']})`,
  marginTop: `calc(-1 * ${theme.eclipseTier1.spacing['12px']})`,
  alignSelf: 'start',

  [`${IconButtonStyles.sel.Button}`]: {
    borderRadius: theme.eclipseTier1.radius['8px'],
    color: 'currentColor',
    opacity: theme.variables.opacity.high,
    outlineOffset: -1,
    '> *': {
      fontSize: '1em',
    },
    [mq.supportsHover]: {
      ':hover': {
        opacity: 1,
      },
    },
  },
}));

const components = { Root, Content, CloseWrapper };

export const S = {
  ...components,
  ...createClassNames('ToastItem', components),
} as const;
